import React from 'react'
import { observer } from 'mobx-react-lite'
import { useStores } from '@trivie/core'
import { Content } from './subscriptions-product-content-tab'

const PurchaseContent = observer(() => {
  const { subscriptionStore } = useStores()
  const purchase = subscriptionStore.selectedPurchase
  return <Content content={purchase?.product_content.slice() ?? []} label="Delivered Content" />
})

export const SubscriptionPurchaseContentTab = (props: any) => {
  const { id } = props
  return {
    name: 'Delivered Content',
    path: `/activities/subscriptions/purchases/${id}/content`,
    component: () => <PurchaseContent />,
  }
}
